import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { createResetData } from "../../hooks/api/utils";
import "../login/login.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const NewPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { email } = location.state || {};

  const [form, setForm] = useState({
    password: "",
    confirm_password: "",
  });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  if (!email) {
    navigate("/");
  }

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.password || !form.confirm_password) return;
    if (form.password !== form.confirm_password) {
      alert("Passwords do not match");
      return;
    }

    const payload = {
      email,
      password: form.password,
      confirm_password: form.confirm_password,
    };

    createResetData("/users/change-password/", setLoading, payload, () =>
      navigate("/")
    );
  };

  return (
    <div className="main-container">
      <div className="main-content">
        <section className="form_part space-cmn">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="signupTab">
                  <div className="formArea loginmain">
                    <form onSubmit={handleSubmit}>
                      <div className="row g-4">
                        <div className="col-md-12 text-center">
                          <h4 className="fs-3 fw-bold">Reset Password</h4>
                        </div>

                        <div className="col-md-12">
                          <label>New Password</label>
                          <div className="position-relative">
                            <input
                              type={showPassword ? "text" : "password"}
                              name="password"
                              className="form-control"
                              placeholder="Enter new password"
                              value={form.password}
                              onChange={handleChange}
                              required
                            />
                            <span
                              className="eye-icon"
                              style={{top:'15px'}}
                              onClick={() => setShowPassword(!showPassword)}
                            >
                              {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-12">
                          <label>Confirm Password</label>
                          <div className="position-relative">
                            <input
                              type={showConfirmPassword ? "text" : "password"}
                              name="confirm_password"
                              className="form-control"
                              placeholder="Confirm new password"
                              value={form.confirm_password}
                              onChange={handleChange}
                              required
                            />
                            <span
                            className="eye-icon"
                            style={{top:'15px'}}
                              onClick={() =>
                                setShowConfirmPassword(!showConfirmPassword)
                              }
                            >
                              {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-12">
                          <button
                            type="submit"
                            className="black_btn"
                            disabled={loading}
                          >
                            {loading ? "Updating..." : "Reset Password"}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default NewPassword;
